import { apiSlice } from './api'
import type { LoginRequest, LoginResponse, RefreshTokenResponse, User } from '../types/auth'
import type { ApiResponse } from '../types/api'

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // 로그인
    login: builder.mutation<LoginResponse, LoginRequest>({
      query: (credentials) => ({
        url: '/auth/login',
        method: 'POST',
        body: credentials,
      }),
    }),
    
    // 로그아웃
    logout: builder.mutation<void, void>({
      query: () => ({
        url: '/auth/logout',
        method: 'POST',
      }),
    }),
    
    // 토큰 갱신
    refreshToken: builder.mutation<RefreshTokenResponse, { refreshToken: string }>({
      query: (body) => ({
        url: '/auth/refresh',
        method: 'POST',
        body,
      }),
    }),
    
    // 토큰 유효성 검사
    validateToken: builder.query<ApiResponse<{ valid: boolean }>, void>({
      query: () => '/auth/validate',
    }),
    
    // 현재 사용자 정보 조회
    getCurrentUser: builder.query<ApiResponse<User>, void>({
      query: () => '/auth/me',
    }),

    // 비밀번호 변경 연기 (PSWD_CHG_PSTPN_DT 갱신)
    postponePasswordChange: builder.mutation<ApiResponse<null>, void>({
      query: () => ({
        url: '/auth/postpone-password',
        method: 'POST',
      }),
    }),

    // 현재 접속한 클라이언트 IP 조회 — 관리자 등록 화면의 "내 IP 확인" 헬퍼용
    getMyClientIp: builder.query<ApiResponse<{ ip: string }>, void>({
      query: () => '/auth/client-ip',
    }),
  }),
})

export const {
  useLoginMutation,
  useLogoutMutation,
  useRefreshTokenMutation,
  useValidateTokenQuery,
  useGetCurrentUserQuery,
  usePostponePasswordChangeMutation,
  useLazyGetMyClientIpQuery,
} = authApi
